// src/website/pages/EventWebsite.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import { ThemeProvider } from '../../context/ThemeContext';
import { useEventData } from '../../hooks/useEventData';
import EventHero from '../Hero/Hero';
import EventAgenda from '../Hero/EventAgenda';
import "./Website.css";

const EventWebsite = () => {
  const { eventId } = useParams();
  const { eventData, loading, error } = useEventData(eventId);

  if (loading) {
    return (
      <div className="website-loading">
        <div className="loading-spinner">Loading Event...</div>
      </div>
    );
  }

  if (error || !eventData) {
    return (
      <div className="website-error">
        <h1>Event Not Found</h1>
        <p>The event you're looking for doesn't exist or hasn't been published yet.</p>
      </div>
    );
  }

  return (
    <ThemeProvider themeSettings={eventData.themeSettings}>
      <div className="event-website">
        <main className="website-main">
          <EventHero event={eventData} />
          <EventAgenda programs={eventData.programs} />
        </main>

        <footer className="website-footer">
          <p>&copy; {new Date().getFullYear()} {eventData.name}. All rights reserved.</p>
        </footer>
      </div>
    </ThemeProvider>
  );
};

export default EventWebsite;